import {
  Container,
  InputAdornment,
  TextField,
  Typography,
} from "@mui/material";
import { useState } from "react";
import { AiOutlineSearch } from "react-icons/ai";
import Box from "@mui/material/Box";
import Paper from "@mui/material/Paper";
import Stack from "@mui/material/Stack";
import { styled } from "@mui/material/styles";
import { Link } from "react-router-dom";
import axios from "axios";

const SearchBar = () => {
  const [filteredData, setFilteredData] = useState([]);
  const [searchTerm, setSearchTerm] = useState("");
  const [loading, setLoading] = useState(false);

  const searchProducts = async (searchQuery) => {
    if (!searchQuery.trim()) {
      setFilteredData([]);
      return;
    }

    try {
      setLoading(true);
      const { data } = await axios.post(
        `${process.env.REACT_APP_BACKEND}/api/product/search`,
        {
          search: searchQuery,
        }
      );
      setFilteredData(data);
    } catch (error) {
      console.error("Search error:", error);
      setFilteredData([]);
    } finally {
      setLoading(false);
    }
  };

  const handleSearch = (event) => {
    const value = event.target.value;
    setSearchTerm(value);
    searchProducts(value);
  };

  const Item = styled(Paper)(({ theme }) => ({
    backgroundColor: theme.palette.mode === "dark" ? "#1A2027" : "#fff",
    ...theme.typography.body2,
    padding: theme.spacing(1),
    textAlign: "center",
    color: theme.palette.text.secondary,
  }));

  return (
    <Container
      style={{
        display: "flex",
        justifyContent: "center",
        alignItems: "center",
        flexDirection: "column",
        padding: 5,
      }}
    >
      <TextField
        id="search"
        type="search"
        label="Qidiruv"
        value={searchTerm}
        onChange={handleSearch}
        sx={{ width: { xs: 350, sm: 500, md: 800 } }}
        InputProps={{
          endAdornment: (
            <InputAdornment position="end">
              <AiOutlineSearch />
            </InputAdornment>
          ),
        }}
      />
      {searchTerm.length > 0 && (
        <Box
          sx={{
            width: { xs: 350, sm: 500, md: 800 },
            overflowY: "scroll",
            height: "200px",
          }}
        >
          <Stack spacing={0}>
            {loading ? (
              <Typography variant="h6" textAlign="center" margin="25px 0">
                Qidirilmoqda...
              </Typography>
            ) : filteredData.length === 0 ? (
              <Typography variant="h6" textAlign="center" margin="25px 0">
                Mahsulot topilmadi
              </Typography>
            ) : (
              filteredData.map((product) => (
                <Link to={`/product/${product.slug}`} key={product._id}>
                  <Item
                    sx={{
                      borderRadius: 0,
                      display: "flex",
                      justifyContent: "space-between",
                      padding: "2px 15px",
                      alignItems: "center",
                    }}
                  >
                    <Typography variant="body2">
                      {product.name.length > 35
                        ? product.name.slice(0, 35) + "..."
                        : product.name}
                    </Typography>
                    <img
                      src={product.url}
                      alt={product.name}
                      style={{ width: 55, height: 65 }}
                    />
                  </Item>
                </Link>
              ))
            )}
          </Stack>
        </Box>
      )}
    </Container>
  );
};

export default SearchBar;
